export default __webpack_public_path__ + "static/media/1833.c10a1e5e.png";